import {SET_TRUBLUE_CONFIG} from './actions.js';

export function setTruBlueConfig(val) {
  return {
    type: SET_TRUBLUE_CONFIG,
    value: val,
  };
}
